module.exports = __webpack_public_path__ + "static/media/letter.d69c2127.svg";